import { render } from "./HomeContentCustom.vue?vue&type=template&id=47e8a882&scoped=true"
import script from "./HomeContentCustom.vue?vue&type=script&lang=ts"
export * from "./HomeContentCustom.vue?vue&type=script&lang=ts"

import "./HomeContentCustom.vue?vue&type=style&index=0&id=47e8a882&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-47e8a882"

export default script